import { TextField } from "@mui/material";
import { IAcmProtocolObject } from "../../services/comm-data-service/Models";

export type ProtocolObjectProps = {
    item: IAcmProtocolObject;
};

export function ProtocolObject({ item }: ProtocolObjectProps) {

    function getValue(): string {
        const values = new Array<string>();
        item.displayText && values.push(`Name: ${item.displayText}`);
        item.acmObjectTypeText && values.push(`Protocol: ${item.acmObjectTypeText}`);
        item.address && values.push(`Protocol Address: ${item.address}`);
        item.ipAddress1 && values.push(`IP Address: ${item.ipAddress1}`);
        item.port1 && values.push(`Port: ${item.port1}`);
        item.properties && item.properties.forEach(p => values.push(`${p.name}: ${p.value}`));
        return values.join("\n");
    }

    return (
        <TextField
            sx={{ width: 1 }}
            label="Protocol Object"
            multiline={true}
            variant="filled"
            value={getValue()}
            slotProps={{
                htmlInput: {
                    readOnly: true
                }
            }}
        />
    );
}